import React from 'react';
// Store
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { checkIsLoading } from 'src/utils/types/statuses';

// UI
import { BaseMultiSelect, BaseSelect } from '../../../common';

type PExpertTemplatesSelect = {
  label?: string;
  [key: string]: any;
  isMulti?: boolean;
};

export const ExpertSelect: React.FC<PExpertTemplatesSelect> = (props) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const guestOptions = user.guests.map((guest: any) => {
    return {
      value: guest.id,
      label: `${guest.first_name} ${guest.last_name}`,
    };
  });
  const { isMulti, label = 'Choose Expert:', ...otherProps } = props as any;

  const fieldOptions = {
    options: guestOptions,
    label,
    loading: checkIsLoading(user),
    ...otherProps,
  };

  const formattedValue = Array.isArray(otherProps.value)
    ? otherProps.value
    : [otherProps.value];

  if (isMulti) {
    return <BaseMultiSelect {...fieldOptions} value={formattedValue} />;
  }

  return <BaseSelect {...fieldOptions} />;
};
